document.addEventListener('DOMContentLoaded', function () {
  function actualizarPrecioTachado() {
    // 1) Precio original (compare-at) de la ficha
    const compareSource = document.querySelector(
      '.price.price--product .price__compare s'
    );
    if (!compareSource) return;

    const compareText = compareSource.textContent.trim();
    if (!compareText) return;

    // 2) Precios tachados del widget de Appstle
    const appstleCompareEls = document.querySelectorAll(
      '.appstle_subscription_compare_amount.transcy-money'
    );
    if (!appstleCompareEls.length) return;

    // 3) Sustituir el contenido
    appstleCompareEls.forEach(function (el) {
      const current = el.textContent.trim();
      if (current !== compareText) {
        el.textContent = compareText;
      }
    });
  }

  function inicializarParaWidget() {
    const widgetRoot = document.querySelector('#appstle_subscription_widget0');
    if (!widgetRoot) return false;

    // aplicar una primera vez (por si ya está renderizado)
    actualizarPrecioTachado();

    // observar cambios dentro del widget (cambios de frecuencia, etc.)
    const observer = new MutationObserver(function () {
      actualizarPrecioTachado();
    });

    observer.observe(widgetRoot, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    return true;
  }

  // Intentar varias veces hasta que exista el widget
  let intentos = 0;
  const maxIntentos = 40;   // ~20 segundos máximo
  const intervalo = 500;

  const timer = setInterval(function () {
    intentos++;
    const iniciado = inicializarParaWidget();
    if (iniciado || intentos >= maxIntentos) {
      clearInterval(timer);
    }
  }, intervalo);
});
